import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type ChangePasswordRows = {
  label: string;
  id: vp.ChangeUserPasswordId;
  preset: keyof vp.TextFieldPresets | undefined;
};
const useBuildLeadCreationRows = (): ChangePasswordRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Users.ChangeUserPassword' });

  return [
    {
      label: t('newPasswordLabel'),
      id: vp.ChangeUserPasswordId.NewPassword,
      preset: 'password',
    },
  ];
};
export default useBuildLeadCreationRows;
